import { Alert, Button, Input, Modal, Spin, Tag, Typography } from "antd";
import { HistoryOutlined, PoweroffOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import dayjs from "dayjs";
import {
  startGetHistorialEstatusProveedor,
  startPostProveedorEstatusMotivo,
} from "../../../../context/actions/proveedoresActions";
import { puedeEstatusProveedor } from "../../../../constants/cons";
import "./proveedorEstatusMotivo.css";

const { Text, Title } = Typography;

export const EstatusProveedor = () => {
  const dispatch = useDispatch();
  const { proveedorID } = useParams();
  const [visible, setVisible] = useState(false);
  const [motivo, setMotivo] = useState("");
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingHistorial, setLoadingHistorial] = useState(false);
  const {
    proveedor: { estaActivo },
    cambiandoEstatus,
  } = useSelector((state) => state.proveedoresReducer);
  const { email } = useSelector((state) => state.userReducer.user);

  const cargarHistorial = async () => {
    setLoadingHistorial(true);
    const data = await dispatch(startGetHistorialEstatusProveedor(proveedorID));
    setHistorial(data || []);
    setLoadingHistorial(false);
  };

  useEffect(() => {
    if (visible) cargarHistorial();
  }, [visible]);

  const handleAction = () => setVisible(true);

  const handleOk = async () => {
    setLoading(true);
    const result = await dispatch(startPostProveedorEstatusMotivo({ proveedorID, motivo }));
    setLoading(false);

    if (result.success) {
      setMotivo("");
      setVisible(false);
    }
  };

  const modal = (
    <Modal
      title={<><PoweroffOutlined className="proveedor-estatus-modal__title-icon" />Actualizar estatus</>}
      open={visible}
      wrapClassName="proveedor-estatus-modal"
      onOk={handleOk}
      onCancel={() => setVisible(false)}
      confirmLoading={loading}
      okButtonProps={{ disabled: !motivo.trim() }}
      okText={estaActivo ? "Desactivar" : "Activar"}
      cancelText="Cancelar"
    >
      <div className="proveedor-estatus-modal__intro">
        <Title level={3} className="proveedor-estatus-modal__heading">
          Motivo del cambio
        </Title>
        <Text type="secondary" className="proveedor-estatus-modal__description">
          Escribe el motivo para {estaActivo ? "desactivar" : "activar"} este proveedor.
        </Text>
      </div>
      <Input.TextArea
        className="proveedor-estatus-modal__textarea"
        value={motivo}
        onChange={(event) => setMotivo(event.target.value)}
        rows={3}
        placeholder="Nuevo motivo"
      />
      <div className="proveedor-estatus-history proveedor-estatus-history--modal">
        <Text className="proveedor-estatus-history__label">
          <HistoryOutlined /> Historial de cambios
        </Text>

        {loadingHistorial ? (
          <div className="proveedor-estatus-history__loading"><Spin /></div>
        ) : historial.length === 0 ? (
          <div className="proveedor-estatus-history__empty">
            <Text className="proveedor-estatus-history__empty-title">Sin cambios registrados</Text>
            <Text type="secondary" className="proveedor-estatus-history__empty-description">
              Cuando se actualice el estatus, el motivo aparecerá en este historial.
            </Text>
          </div>
        ) : (
          historial.map((item, index) => (
            <div className="proveedor-estatus-history__item" key={`${item.fecha}-${index}`}>
              <div className="proveedor-estatus-history__meta">
                <Text strong>{item.usuarioNombre}</Text>
                <Tag color={item.estatus === "Activado" ? "green" : "red"}>{item.estatus}</Tag>
                <Text type="secondary">{dayjs(item.fecha).format("DD/MM/YYYY HH:mm")}</Text>
              </div>
              <div className="proveedor-estatus-history__motivo">{item.motivo}</div>
            </div>
          ))
        )}
      </div>
    </Modal>
  );

  if (!puedeEstatusProveedor.includes(email)) return <></>;

  if (cambiandoEstatus)
    return (
      <div style={{ textAlign: "right", paddingRight: 30, marginTop: 10 }}>
        <Spin />
      </div>
    );

  if (estaActivo)
    return (
      <>
        <Alert
          type="success"
          message="Proveedor Activo"
          action={
            <Button onClick={handleAction} size="small" type="text">
              Desactivar
            </Button>
          }
        />
        {modal}
      </>
    );

  return (
    <>
      <Alert
        type="error"
        message="Proveedor Inactivo"
        action={
          <Button onClick={handleAction} size="small" type="text">
            Activar
          </Button>
        }
      />
      {modal}
    </>
  );
};
